import React, { Component } from "react";
import axios from "../axios";

// import { Container } from 'semantic-ui-react'

import VerifyPhoneForm from "../forms/VerifyPhoneForm";
import VerifySmsCodeForm from "../forms/VerifySmsCodeForm";

class VerifyPhonePage extends Component {
    state = {
        status: 1,
        phone: "",
        country: "",
    };

    sendSms(data) {
        console.log(data);
        // var formData = new FormData();
        // formData.append("mobile", data.country_text.replace("+", "")+data.phone);

        this.props.onSubmit(
            data.country_text + data.phone,
            "1111",
            data.country
        );

        // return axios.post(window.restaurant.url+window.restaurant.url_checkPhone+"?lang="+window.options.lang, formData)
        // .then(res => {
        // 	console.log(res);

        // 	if(res.data.success === true) {
        // 		this.setState({
        // 			status: 2,
        // 			phone: data.country_text+data.phone,
        // 			country: data.country
        // 		});
        // 	} else {
        // 		return Promise.reject(!!res.data.message ? res.data.message : 'Something went wrong...');
        // 	}

        // 	return Promise.resolve(res.data);
        // });
    }

    verifyCode(data) {
        var formData = new FormData();
        formData.append("mobile", this.state.phone.replace("+", ""));
        formData.append("code", data.code);

        return axios
            .post(
                window.restaurant.url +
                    window.restaurant.url_checkCode +
                    "?lang=" +
                    window.options.lang,
                formData
            )
            .then((res) => {
                console.log(res);
                if (res.data.success === true) {
                    this.props.onSubmit(
                        this.state.phone,
                        data.code,
                        this.state.country
                    );
                } else {
                    return Promise.reject(
                        !!res.data.message
                            ? res.data.message
                            : "Something went wrong..."
                    );
                }

                return Promise.resolve(res.data);
            });
    }

    render() {
        const { status } = this.state;

        return (
            <div id="VerifyPhonePage">
                {status === 1 && (
                    <VerifyPhoneForm onSubmit={this.sendSms.bind(this)} />
                )}
                {status === 2 && (
                    <VerifySmsCodeForm onSubmit={this.verifyCode.bind(this)} />
                )}
            </div>
        );
    }
}

export default VerifyPhonePage;



// WEBPACK FOOTER //
// ./src/components/pages/VerifyPhonePage.js